import { MutableRefObject, ReactNode } from "react";
import "./InputWithLabel.scss";

type Props = {
  label: string | ReactNode;
  inputId: string;
  value: string;
  onValueChange: Function;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  inputRef?: MutableRefObject<null>;
  icon?: ReactNode;
  placeholder?: string;
  error?: string;
  validateInput?: boolean | false;
  handleValidation?: Function;
};
// Component to show a label and an input
// Pass in type date as a prop to get a datepicker etc
// inputId is the identifier for the input, and the name of the field that will be set

const InputWithLabel = (props: Props) => {
  const {
    label,
    inputId,
    value,
    onValueChange,
    required,
    disabled,
    inputRef,
    icon,
    placeholder,
    error,
    validateInput,
    handleValidation,
  } = props;
  const handleChange = (e: { currentTarget: { value: string } }) => {
    onValueChange(inputId, e.currentTarget.value);
  };

  const checkValidation = (e: { currentTarget: { value: string } }) => {
    handleValidation && handleValidation(inputId, e.currentTarget.value);
  };

  return (
    <div
      className={`text-input-container ${
        disabled ? "text-input-container--disabled" : ""
      }`}
    >
      <label className="text-input-container__input-label" htmlFor={inputId}>
        {label}
        {required && <span className="required">*</span>}
      </label>
      {props.icon}
      <input
        onChange={handleChange}
        className={`text-input-container__input-field ${
          error ? "text-input-container__input-field--error" : ""
        }`}
        id={inputId}
        value={value}
        onBlur={validateInput ? checkValidation : handleChange}
        type={props.type || ""}
        disabled={disabled}
        maxLength={props.maxLength || 0}
        ref={inputRef && inputRef}
        placeholder={props.placeholder}
        autoComplete="none"
      />
      {error && (
        <span className="text-input-container__error-message">{error}</span>
      )}
    </div>
  );
};

export default InputWithLabel;
